const convertExpiresDateToUTCString = expires => {
	if (expires && typeof expires === "number") {
		const date = new Date();

		date.setTime(
			date.getTime() + expires * 1000
		);

		expires = date;
	}

	if (expires && expires.toUTCString) {
		expires = expires.toUTCString();
	}

	return expires;
};

export default class Cookie {
	constructor() {
		throw new Error('this class can\'t be an instance');
	}

	static get(name) {
		// eslint-disable-next-line
		name = name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1');

		const
			regExp = new RegExp(`(?:^|; )${name}=([^;]*)`),
			matches = document.cookie.match(regExp);

		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	static set(	name, value, options = {
		path: '/',
		expires: 60 * 60 * 24 * 365 // One year in seconds by default
	}) {
		options.expires = convertExpiresDateToUTCString(options.expires);

		const
			optionKeys = Object.keys(options),
			cookieStr = `${name}=${encodeURIComponent(value)}`,
			concatOptions = (str, key) => `${str}; ${key}=${options[key]}`;

		document.cookie = optionKeys.reduce(concatOptions, cookieStr);
	}

	static clear(name){
		Cookie.set(name, "", { expires: -1 });
	}
}